export enum TransactionStatus {
    PROCESSED = '1',
    PENDING = '2',
    FAILED = '-1',
    CANDELLED = '-2'
}
